import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("C:/opt/yoien-cloud-frontend/layouts/default.vue").then(m => m.default || m)),
  page: defineAsyncComponent(() => import("C:/opt/yoien-cloud-frontend/layouts/page.vue").then(m => m.default || m)),
  simple: defineAsyncComponent(() => import("C:/opt/yoien-cloud-frontend/layouts/simple.vue").then(m => m.default || m))
}